"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Overview(_a) {
    var livestream = _a.livestream, channel = _a.channel;
    var _b = react_1.useState(new Date()), date = _b[0], setDate = _b[1];
    var _c = react_1.useState(false), create = _c[0], setCreate = _c[1];
    var _d = react_1.useState({}), edit = _d[0], setEdit = _d[1];
    var _e = ra_fetch_1.useApi('media').index('events', {
        livestream_id: livestream.livestream_id,
        channel_id: livestream.channel_id,
        date: storybook_1.Helpers.date_to_string(date),
        subdays: 2,
        limit: 5,
        sort: 'start asc',
    }), events = _e[0], setEvents = _e[1], params = _e[2], setParams = _e[3];
    function changeDate(date) {
        if (date) {
            setDate(new Date(date));
            setParams(__assign(__assign({}, params), { date: date }));
        }
    }
    return react_1.default.createElement("div", { className: 'storybook-events-overview' },
        react_1.default.createElement("div", { className: 'storybook-events-overview-days' },
            react_1.default.createElement(storybook_1.Events.Days, { data: events.meta, setDate: changeDate }),
            react_1.default.createElement(storybook_1.Forms.Input, { type: 'date', name: 'schedule', value: storybook_1.Helpers.date_to_string(date), placeholder: 'Datum van de livestream', onChange: changeDate })),
        events.loading && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' }),
        events.data
            .sortBy('start', 'asc')
            .map(function (event, key) {
            if (edit.id === event.id) {
                return react_1.default.createElement(storybook_1.Events.Save, { channel: channel, current: event, events: events, key: key, setEvents: setEvents, date: date, onSuccess: function () { return setEdit({}); } });
            }
            return react_1.default.createElement(storybook_1.Events.Show, { key: key, event: event, onEdit: function () { return setEdit(event); } });
        }),
        create && react_1.default.createElement(storybook_1.Events.Save, { channel: channel, livestream: livestream, onSuccess: function () { return setCreate(false); }, date: date, events: events, setEvents: setEvents }),
        !create && !edit.id && react_1.default.createElement("div", { className: 'storybook-events-overview-new', onClick: function () { return setCreate(true); } },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'plus' })));
}
exports.default = Overview;
